<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white">
    <page class="h-full" :head-text="$t('login.sign_up_store')">
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <div class="input-wrapper relative mb-10">
          <input
            class="w-full h-12 pl-6 outline-none"
            type="text"
            autofocus
            v-model="account"
            :placeholder="$t('login.customer_account_name')"
            @keyup.enter="registerStore"
          />
        </div>
        <c-button :confirmed-status="!!account" class="relative" @click="registerStore">
          <span>{{ $t('login.sign_up') }}</span>
        </c-button>
      </template>
    </page>
  </div>
</template>

<script>
import ApiActions from '@/modules/api-actions';
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  components: {
    Page,
    CButton,
  },
  data() {
    return {
      account: '',
    };
  },
  methods: {
    async registerStore() {
      if (!this.account) return;

      this.$events.startLoading();

      try {
        const userAuth = await ApiActions.mtm.registerMember({
          member_number: this.account,
          provider: 0,
        });
        ApiActions.user.setAuth(userAuth);
        await ApiActions.user.auth(userAuth);
        this.$emit('done', this.account);
      } catch (e) {
        console.log(e.message);
        this.$events.stopLoading();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  width: 309px;

  input {
    @apply bg-no-repeat;
    @apply bg-contain;
    @apply bg-white;
    background-image: url('../../../assets/common/rectangle-1334.svg');
  }
}
</style>
